import * as React from "react";
var FadeAnimation = function (props) {
    var _a = React.useState(false), mounted = _a[0], setMouted = _a[1];
    React.useEffect(function () {
        setMouted(true);
        props.onEnter();
        return function () {
        };
    }, []);
    React.useEffect(function () {
        if (props.in == false) {
            setTimeout(function () {
                props.onExited();
            }, 300); // Animation duration!
        }
    }, [props.in]);
    return React.createElement("div", { className: props.in && mounted ? "slide-down" : "slide-up", style: (mounted) ? {} : { opacity: 0 } }, props.children);
};
export default FadeAnimation;
//# sourceMappingURL=FadeAnimation.js.map